import {
  faAnglesRight,
  faEnvelope,
  faPhoneVolume,
} from "@fortawesome/free-solid-svg-icons";
import ContactsElement from "./ContactsElement";

import Style from "./Contacts.module.css";
import { forwardRef } from "react";
import PrimaryButton from "../UI/Buttons/PrimaryButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useI18n } from "../../i18n/I18nContext";

const ContactsSection = forwardRef((props, ref) => {
  const { copy } = useI18n();
  const contactCopy = copy.home.contact;

  return (
    <div ref={ref} className={Style["contacts-section-wrapper"]}>
      <h1 className={Style["contact-us-heading"]}>{contactCopy.title}</h1>
      <div className={Style["book-btn-container"]}>
        <PrimaryButton
          padding="2rem 5rem"
          fontSize="2rem"
          onClick={() =>
            window.open("https://calendly.com/contact-warenex/30min")
          }
        >
          {copy.common.bookMeeting} &nbsp;
          <FontAwesomeIcon icon={faAnglesRight} size="2x" color="#fff" />
        </PrimaryButton>
      </div>
      <h2>{contactCopy.directContactTitle}</h2>
      <div className={Style["contacts-elements-container"]}>
        <ContactsElement
          icon={faPhoneVolume}
          heading={contactCopy.phoneHeading}
          text={contactCopy.phoneText}
          contacts="+359 87 731 0641"
          href="tel:+359 87 731 0641"
        />
        <div className={Style["stroke"]}></div>
        <ContactsElement
          icon={faEnvelope}
          heading={contactCopy.emailHeading}
          text={contactCopy.emailText}
          contacts="contact@warenex.com"
          href="mailto:contact@warenex.com"
        />
      </div>
    </div>
  );
});

export default ContactsSection;
